module.exports = __webpack_public_path__ + "static/media/neg-y.3a97b140.jpg";